import { createAction } from "redux-actions";
import { moduleSlug } from "modules/ProxyManager/constants";

export const clearProxies = createAction(`${moduleSlug}/CLEAR_PROXIES`);

export const setSelectedProxies = createAction(`${moduleSlug}/SET_SELECTED_PROXIES`);

export const getProxies = createAction(`${moduleSlug}/GET_PROXIES`);
export const getProxiesSuccess = createAction(`${moduleSlug}/GET_PROXIES/SUCCESS`);
export const getProxiesError = createAction(`${moduleSlug}/GET_PROXIES/ERROR`);

export const createProxies = createAction(`${moduleSlug}/CREATE_PROXIES`);
export const createProxiesSuccess = createAction(`${moduleSlug}/CREATE_PROXIES/SUCCESS`);
export const createProxiesError = createAction(`${moduleSlug}/CREATE_PROXIES/ERROR`);

export const deleteProxy = createAction(`${moduleSlug}/DELETE_PROXY`);

export const exportProxiesToCSV = createAction(`${moduleSlug}/EXPORT_PROXIES_TO_CSV`);

export const setAttachExistedTagDialog = createAction(`${moduleSlug}/SET_ATTACH_EXISTED_TAG_DIALOG`);
export const mergeAttachExistedTagDialog = createAction(`${moduleSlug}/MERGE_ATTACH_EXISTED_TAG_DIALOG`);
export const attachExistedTag = createAction(`${moduleSlug}/ATTACH_EXISTED_TAG`);

export const setAttachNewTagDialog = createAction(`${moduleSlug}/SET_ATTACH_NEW_TAG_DIALOG`);
export const mergeAttachNewTagDialog = createAction(`${moduleSlug}/MERGE_ATTACH_NEW_TAG_DIALOG`);
export const attachNewTag = createAction(`${moduleSlug}/ATTACH_NEW_TAG`);

export const setDetachTagDialog = createAction(`${moduleSlug}/SET_DETACH_TAG_DIALOG`);
export const mergeDetachTagDialog = createAction(`${moduleSlug}/MERGE_DETACH_TAG_DIALOG`);
export const detachTag = createAction(`${moduleSlug}/DETACH_TAG`);

export const getCountProxies = createAction(`${moduleSlug}/GET_COUNT_PROXIES`);
export const getCountProxiesSuccess = createAction(`${moduleSlug}/GET_COUNT_PROXIES/SUCCESS`);
export const getCountProxiesError = createAction(`${moduleSlug}/GET_COUNT_PROXIES/ERROR`);

export const setImportProxiesDialog = createAction(`${moduleSlug}/SET_IMPORT_PROXIES`);
export const mergeImportProxiesDialog = createAction(`${moduleSlug}/MERGE_IMPORT_PROXIES_DIALOG`);
export const importProxiesDialog = createAction(`${moduleSlug}/IMPORT_PROXIES`);

export const setProxyDialog = createAction(`${moduleSlug}/SET_PROXY_DIALOG`);
export const mergeProxyDialog = createAction(`${moduleSlug}/MERGE_PROXY_DIALOG`);
export const createProxy = createAction(`${moduleSlug}/CREATE_PROXY`);
